module.exports = __webpack_public_path__ + "img/bench-tree.6b9eae12.svg";